import {ClockComponentDefaultBox} from "./clock.component.default.box";

export const ClockComponentBox = ClockComponentDefaultBox;